/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'townsquare-comments.comment-action-bar.delete-button': 'Supprimer',
  'townsquare-comments.comment-action-bar.edit-button': 'Modifier',
  'townsquare-comments.comment-action-bar.reply-button': 'Répondre',
  'townsquare-comments.comment.edited-date': 'Modifié : {time}',
  'townsquare-comments.comments.comments-title':
    '{itemCount, plural, =0 {Commentaires} one {{itemCount,number} commentaire} other {{itemCount,number} commentaires}}',
};
